//export const apiUrl =  'http://localhost:59485/'
export const apiUrl =  'https://qaapi.xpindia.in/'
//export const apiUrl =  'https://liveapi.xpindia.in/'

// export const coreApiUrl =  'https://localhost:7018/'
export const coreApiUrl = 'https://qacore.xpindia.in/'
//export const coreApiUrl = 'https://coreapi.xpindia.in/'

